import styled, { Interpolation } from "styled-components";
import { colors } from "@/theme";

export const CartItemPropertyContainer = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 30% 70%;
`;

export interface CartItemPropertyContainerProps {
  $styles?: Interpolation<React.CSSProperties>;
}

export const CartItemPropertyNameContainer = styled.div<CartItemPropertyContainerProps>`
  ${({ $styles }) => $styles}
  ${({ $styles }) =>
    !($styles as { [key: string]: any })?.["textAlign"] &&
    `text-align: center;`}
  ${({ $styles }) =>
    !($styles as { [key: string]: any })?.["alignSelf"] &&
    `align-self: center;`}
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CartItemPropertyChildrenContainer = styled.div<CartItemPropertyContainerProps>`
  ${({ $styles }) => $styles}
  ${({ $styles }) =>
    !($styles as { [key: string]: any })?.["placeSelf"] &&
    `place-self: center;`}
`;
